import { productPaymentConfigService } from '@/services';
import { useQuery } from '@tanstack/react-query';
import { PRODUCT_PAYMENT_SETTINGS_QUERY_KEY } from './use-product-payment-settings-list.hook';

/** Cobrança pelo gateway e catálogo de formas de um produto. */
export function useProductPaymentSettings(productCode: string) {
  return useQuery({
    queryKey: [...PRODUCT_PAYMENT_SETTINGS_QUERY_KEY, productCode],
    queryFn: async () => {
      const response =
        await productPaymentConfigService.getPaymentSettings(productCode);
      if (!response.success || !response.data) {
        throw new Error(
          response.error ||
            'Não foi possível carregar as formas de pagamento do produto.'
        );
      }
      return response.data;
    },
    enabled: Boolean(productCode),
  });
}
